export interface ISplitButtonItem {
	label: string;
	icon: string;
	command: () => void;
}

export enum CycleStatusEnum {
	Draft = 'טיוטה',
	PrivateTemplate = 'תבנית פרטית',
	PublicTemplate = 'תבנית ציבורית',
	PrivateForm = 'טופס פרטי',
	PublicForm = 'טופס ציבורי',
	Completing = 'בתהליך סיום',
	Completed = 'הסתיים',
	Denying = 'בתהליך דחייה',
	Denied = 'נדחה',
	Canceling = 'בתהליך ביטול',
	Canceled = 'בוטל',
	Cycling = 'בתהליך',
	Expired = 'פג תוקף',
	FormFill = 'מילוי טופס',
}
